// import components
import Grid from '@mui/material/Grid';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { GridContainer } from 'components/shared/Grid/Grid.components';

// import hooks
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useEditPageContext } from 'components/shared/CRUD/components/InnerPage/EditPageContext';

// import types
import { TabProps } from '../CLASettings.types';

// import utils
import {
  expiryHoursInOctopusFields,
  expiryHoursInOctopusSchema
} from './ExpiryHoursInOctopusTab.utils';
import { ControlledCheckbox } from 'components/shared/ControlledFields';

const ExpiryHoursInOctopusTab = ({ setCurrentSchema }: TabProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla'
  });
  const { control, setValue } = useFormContext();
  const { isEditable } = useEditPageContext();

  useEffect(() => {
    setCurrentSchema(expiryHoursInOctopusSchema);
  }, []);

  return (
    <MultiStepForm.Section title={t('sectionTitles.expiryHoursInOctopus')}>
      <GridContainer>
        {expiryHoursInOctopusFields.map((item, id) => (
          <Grid
            key={`expiryHoursInOctopus_grid_${id}`}
            size={{
              compact: 6,
              medium: 4
            }}
          >
            <ControlledCheckbox
              key={`expiryHoursInOctopus_${id}`}
              disabled={!isEditable}
              onChange={(event) => setValue(item.name, event.target.checked)}
              control={control}
              name={item.name}
              label={t(item.label)}
            />
          </Grid>
        ))}
      </GridContainer>
    </MultiStepForm.Section>
  );
};

export default ExpiryHoursInOctopusTab;
